import store from "store";

export const getRemoteValue = (Key: string):Promise<any> => {
    return new Promise((resolve, reject) => {
        resolve(store.get(Key))
    })
}

export const setRemoteValue = (Key: string, v: string) => {
    return store.set(Key, v)
}